import React, {Component} from 'react';

import {TableLayout} from '../Menu/Stock/containers/Layout';

import SearchBar from './Layouts/SeachBar';
import Dialog from '../../commonModules/interface/Dialog';
import InputText from '../../commonModules/interface/form-input-inline';
import {connect} from 'react-redux';

import {disableSubscription, changeStockManagementSubscription} from '../../../../../jsx/actions/subscriptionAction'
import { getPaygClients } from '../../../../../jsx/actions/clientAction';

import NewSubscription from '../Menu/module/paygoNewSubscription';
import {isEmpty} from 'lodash'
import Currency from '../../commonModules/Currency';

import { Table, TableBody, TableRow, TableCell, Grid, Button, TableHead, Card, Box, TableContainer } from '@material-ui/core';
import { TabletMacRounded, LocalShippingRounded, FilterRounded, PlayArrowRounded } from '@material-ui/icons';
import NewSimulPrepaid from '../Menu/module/newSubscription/NewSimulPrepaid';
import SubscriptionUpdateForms from './Subscription/SubscriptionUpdateForms';
import CardButton from '../../commonModules/interface/CardButton';
import DeleteDialog from '../../commonModules/interface/DeleteDialog';
import SearchBarAction from './Layouts/SearchBarAction';
import PageAdmin from './Layouts/PageAdmin';
import { toast } from 'react-toastify';

const formatNumber = (val) => {
    const num = parseFloat(val) || 0;
    return num.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

class SubscriptionsList extends Component {
    state = {
        form: "",
        new: false,
        list: [],
        mdpAdmin: '',
        errors: {
            mdpAdmin: ''
        },
        dialogDelete: false,
        deleteSub: {},
        openDialog: false,
        currentSub: {}
    }
    componentDidMount = async () => {
        const { SUBSCRIPTIONS, STATE } = this.props;
        console.log('====================================');
        console.log(STATE.paygClients);
        console.log('====================================');
        if (isEmpty(SUBSCRIPTIONS)) {
            await this.props.fetchSubscriptions()
        }
        if(!STATE.paygClients.fetched){
            console.log('================FETCHIING CLIENTS====================');
            console.log('====================================');

            // important action to get Subscriptions stats /!\
            await this.props.getClients() // not working
        }
        this.filterList()
    }
    filterList = (list) => {
        if (!list) {
            if (!isEmpty(this.props.SUBSCRIPTIONS)) {
                list = Object.keys(this.props.SUBSCRIPTIONS)
            } else {
                list = []
            }
        }
        this.setState({list})
    }
    handleChange = (e) => {
        const field = e.target.name
        const value = e.target.value
        this.setState({[field]: value})
    }
    disableSubscription = async (sub) => {
        console.log('[INFO] disableSubscription.jsx');
        this.props.disableSubscription(sub)
    }
    changeStockManagement = async (sub) => {
        console.log('[INFO] changeStockManagement');
        await this.props.changeStockManagementSubscription(sub)
        console.log('====================================');
        console.log(this.props.STATE);
        console.log(this.props.STATE.subscriptions);
        console.log('====================================');
        if (this.props.STATE.subscriptions.error){
            console.log("ERROR", this.props.STATE.subscriptions.error);
            toast.error(  this.props.STATE.subscriptions.error)
        } else {
            console.log("SUCCESS", this.props.STATE.subscriptions);
            toast.info( "Abonnement modifié avec succès")
        }   
    }
    deleteSubscription = async () => {
        console.log('[INFO] delete subscriptionsList.jsx');
        // Password verification is now handled by the backend
        // Note: For subscriptions, password is optional (backend checks only if provided)
        await this.props.deleteSubscription(this.state.deleteSub)

        if (this.props.STATE.subscriptions.error) {
            console.log("[ERROR] delete abo", this.props.STATE.subscriptions.error);
            const errorMsg = this.props.STATE.subscriptions.error;
            if (typeof errorMsg === 'string' && errorMsg.includes("Mot de passe")) {
                toast.error(errorMsg);
            } else {
                toast.error("Un Problème est survenu");
            }
        } else {
            //success
            toast.success("Abonnement supprimé avec succès")
            this.setState({
                dialogDelete: false,
                deleteSub: {}
            })
        }
    }

    render() {
        const {SUBSCRIPTIONS, STATS_SUB} = this.props;
        const {currentSub, openDialog, dialogDelete, deleteSub} = this.state;
        let subscribed_list = isEmpty(STATS_SUB) ? null : Object.keys(STATS_SUB)

        console.log('=============[PROPS]=======================');
        console.log(this.props);
        console.log('====================================');
        return (
            <PageAdmin title="Abonnements">
                {this.state.new && 
                    <NewSubscription
                        popupState={"overlay"}
                        onCloseOverlay={() => this.setState({new: false})}
                    />
                }
                {dialogDelete && 
                    <DeleteDialog
                        title={"l'abonnement \"" + deleteSub.name + "\""}
                        // text={deleteForm}
                        handleSubmit={this.deleteSubscription}
                        // submitTitle="Supprimer"
                        open={true}
                        close={() => this.setState({dialogDelete: false, deleteSub: {}})}
                    />
                }
                {openDialog && 
                <Dialog
                    title={currentSub.name}
                    block={true}
                    close={() => this.setState({openDialog: false, currentSub: {}, form: ""})}
                    maxWidth="md"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={8}>
                            {/* Informations générales */}
                            <TableContainer>
                                <Table>
                                    <TableBody className="text-left">
                                        <TableRow>
                                            <TableCell colSpan={2}>Type : </TableCell>
                                            <TableCell colSpan={2}><strong>{currentSub.type}</strong></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={2}>Stock : </TableCell>
                                            <TableCell colSpan={2}>{currentSub.stocklink === "nolink" ? "Non" : "Oui"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={2}>Déblocage : </TableCell>
                                            <TableCell colSpan={2}>{currentSub.unlockthirdParty}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* === jouly-prepaid-kwh === */}
                            {currentSub.type === "jouly-prepaid-kwh" && currentSub.prepaid_kwh &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>Compteur Prépayé - Détail Tarification</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Coût de raccordement</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.installCost || currentSub.deposit)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>kWh offerts au raccordement</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.initialkWh || 0} kWh</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Partie fixe mensuelle</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.fixcost)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Durée partie fixe</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.fixduration || 31} jours</TableCell>
                                        </TableRow>
                                        {currentSub.prepaid_kwh.maxpower > 0 &&
                                        <TableRow>
                                            <TableCell>Puissance maximale</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.maxpower} W</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.prepaid_kwh.pricestepList && currentSub.prepaid_kwh.pricestepList[0] &&
                                        <TableRow>
                                            <TableCell>Prix variable</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.pricestepList[0].price)} pour {currentSub.prepaid_kwh.pricestepList[0].kwh} kWh</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.miniPayment > 0 &&
                                        <TableRow>
                                            <TableCell>Paiement minimum</TableCell>
                                            <TableCell>{formatNumber(currentSub.miniPayment)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.prepaid_kwh.external_link &&
                                        <TableRow>
                                            <TableCell>Liaison externe</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.external_link}</TableCell>
                                        </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            }

                            {/* === prepaid-kwh-v2 === */}
                            {currentSub.type === "prepaid-kwh-v2" && currentSub.prepaid_kwh &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>Compteur Prépayé V2 - Détail Tarification</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Coût de raccordement</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.installCost || currentSub.deposit)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>kWh offerts au raccordement</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.initialkWh || 0} kWh</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Partie fixe mensuelle</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.fixcost)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Durée partie fixe</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.fixduration || 31} jours</TableCell>
                                        </TableRow>
                                        {currentSub.prepaid_kwh.maxpower > 0 &&
                                        <TableRow>
                                            <TableCell>Puissance maximale</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.maxpower} W</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.miniPayment > 0 &&
                                        <TableRow>
                                            <TableCell>Paiement minimum</TableCell>
                                            <TableCell>{formatNumber(currentSub.miniPayment)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.prepaid_kwh.external_link &&
                                        <TableRow>
                                            <TableCell>Liaison externe</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.external_link}</TableCell>
                                        </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                                {!isEmpty(currentSub.prepaid_kwh.pricestepList) &&
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={3} style={{textAlign: "center"}}><strong>Grille tarifaire (prix au kWh)</strong></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th">Tranche</TableCell>
                                            <TableCell component="th">Seuil (kWh)</TableCell>
                                            <TableCell component="th">Prix / kWh</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {currentSub.prepaid_kwh.pricestepList.map((step, idx, arr) => {
                                            let prevSeuil = idx === 0 ? 0 : arr[idx - 1].kwh;
                                            let label = step.kwh > 0 ? `${prevSeuil} → ${step.kwh} kWh` : `${prevSeuil}+ kWh`;
                                            return (
                                                <TableRow key={idx}>
                                                    <TableCell>{label}</TableCell>
                                                    <TableCell>{step.kwh > 0 ? step.kwh : "illimité"}</TableCell>
                                                    <TableCell>{formatNumber(step.price)} / kWh</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                                }
                            </TableContainer>
                            }

                            {/* === jouly-prepaid-kwh-limit-day === */}
                            {currentSub.type === "jouly-prepaid-kwh-limit-day" && currentSub.prepaid_kwh &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>Compteur Prépayé Limité - Détail Tarification</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Coût de raccordement</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.installCost || currentSub.deposit)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Prix du kWh</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.pricestepList && currentSub.prepaid_kwh.pricestepList[0] ? currentSub.prepaid_kwh.pricestepList[0].price : 0)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>kWh par jour</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.kwhperday || 0} kWh</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Partie fixe mensuelle</TableCell>
                                            <TableCell>{formatNumber(currentSub.prepaid_kwh.fixcost)}</TableCell>
                                        </TableRow>
                                        {currentSub.prepaid_kwh.maxpower > 0 &&
                                        <TableRow>
                                            <TableCell>Puissance maximale</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.maxpower} W</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.miniPayment > 0 &&
                                        <TableRow>
                                            <TableCell>Paiement minimum</TableCell>
                                            <TableCell>{formatNumber(currentSub.miniPayment)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.prepaid_kwh.external_link &&
                                        <TableRow>
                                            <TableCell>Liaison externe</TableCell>
                                            <TableCell>{currentSub.prepaid_kwh.external_link}</TableCell>
                                        </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            }

                            {/* === Kwh / PayGo-Kwh === */}
                            {(currentSub.type === "Kwh" || currentSub.type === "PayGo-Kwh") && currentSub.kwh &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>Tarification au kWh</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {currentSub.kwh.aboPrice > 0 &&
                                        <TableRow>
                                            <TableCell>Abonnement ({currentSub.kwh.abo || "mensuel"})</TableCell>
                                            <TableCell>{formatNumber(currentSub.kwh.aboPrice)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.kwh.unlockPrice > 0 &&
                                        <TableRow>
                                            <TableCell>Prix de déblocage</TableCell>
                                            <TableCell>{formatNumber(currentSub.kwh.unlockPrice)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.kwh.installCost > 0 &&
                                        <TableRow>
                                            <TableCell>Coût d'installation</TableCell>
                                            <TableCell>{formatNumber(currentSub.kwh.installCost)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.kwh.maxCredit > 0 &&
                                        <TableRow>
                                            <TableCell>Crédit maximum</TableCell>
                                            <TableCell>{formatNumber(currentSub.kwh.maxCredit)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.deposit > 0 &&
                                        <TableRow>
                                            <TableCell>Dépôt initial</TableCell>
                                            <TableCell>{formatNumber(currentSub.deposit)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.miniPayment > 0 &&
                                        <TableRow>
                                            <TableCell>Paiement minimum</TableCell>
                                            <TableCell>{formatNumber(currentSub.miniPayment)}</TableCell>
                                        </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                                {currentSub.kwh.hoursList && currentSub.kwh.hoursList.length > 0 &&
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={3} style={{textAlign: "center"}}><strong>Plages horaires</strong></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th">Période</TableCell>
                                            <TableCell component="th">Début</TableCell>
                                            <TableCell component="th">Fin</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {currentSub.kwh.hoursList.map((h, idx) =>
                                            <TableRow key={idx}>
                                                <TableCell>{h.HoursName === "day" ? "Jour" : h.HoursName === "evening" ? "Soir" : "Nuit"}</TableCell>
                                                <TableCell>{Math.floor(h.hourstart / 60)}h{String(h.hourstart % 60).padStart(2, '0')}</TableCell>
                                                <TableCell>{Math.floor(h.hourstop / 60)}h{String(h.hourstop % 60).padStart(2, '0')}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                                }
                                {currentSub.kwh.priceList &&
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4} style={{textAlign: "center"}}><strong>Grille de Prix kWh</strong></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th">Jour</TableCell>
                                            <TableCell component="th">Jour</TableCell>
                                            <TableCell component="th">Soir</TableCell>
                                            <TableCell component="th">Nuit</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {["monday","tuesday","wednesday","thursday","friday","saturday","sunday"].map((dayName, idx) => {
                                            let slots = currentSub.kwh.priceList[dayName]
                                            let labels = ["Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi","Dimanche"]
                                            return slots && slots.length > 0 ? (
                                                <TableRow key={idx}>
                                                    <TableCell>{labels[idx]}</TableCell>
                                                    {slots.map((s, si) =>
                                                        <TableCell key={si}>{formatNumber(s.Price)}</TableCell>
                                                    )}
                                                </TableRow>
                                            ) : null
                                        })}
                                    </TableBody>
                                </Table>
                                }
                            </TableContainer>
                            }

                            {/* === PayGo-Day === */}
                            {currentSub.type === "PayGo-Day" &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>PayGo Jour - Détail</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Prix par jour</TableCell>
                                            <TableCell>{formatNumber(!isEmpty(currentSub.day.timePrice) ? currentSub.day.timePrice[0].Price : 0)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Dépôt initial</TableCell>
                                            <TableCell>{formatNumber(currentSub.deposit)} pour {currentSub.depositDay} jours</TableCell>
                                        </TableRow>
                                        {currentSub.condition && currentSub.condition[0] &&
                                        <TableRow>
                                            <TableCell>Prix total pour débloquer</TableCell>
                                            <TableCell>{formatNumber(currentSub.condition[0].totalToPay)}</TableCell>
                                        </TableRow>
                                        }
                                        {currentSub.miniPayment > 0 &&
                                        <TableRow>
                                            <TableCell>Paiement minimum</TableCell>
                                            <TableCell>{formatNumber(currentSub.miniPayment)}</TableCell>
                                        </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            }

                            {/* === Day / Cash (existant amélioré) === */}
                            {(currentSub.type === "Day" || currentSub.type === "Cash") &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>Détail</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Prix Total</TableCell>
                                            <TableCell>{formatNumber(currentSub.total)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Dépôt initial</TableCell>
                                            <TableCell>{formatNumber(currentSub.deposit)} pour {currentSub.depositDay} jours</TableCell>
                                        </TableRow>
                                        {currentSub.miniPayment > 0 &&
                                        <TableRow>
                                            <TableCell>Paiement minimum</TableCell>
                                            <TableCell>{formatNumber(currentSub.miniPayment)}</TableCell>
                                        </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                                {!isEmpty(currentSub.day) && !isEmpty(currentSub.day.timePrice) &&
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4} style={{textAlign: "center"}}><strong>Grille de Prix</strong></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell component="th">Périodicité</TableCell>
                                            <TableCell component="th">Jour</TableCell>
                                            <TableCell component="th">Mois</TableCell>
                                            <TableCell component="th">Année</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {currentSub.day.timePrice.map((item, idx) =>
                                            <TableRow key={idx}>
                                                <TableCell>{item.Day + item.Month * 30 + item.Year * 365} j</TableCell>
                                                <TableCell>{item.Day === 1 && formatNumber(item.Price)}</TableCell>
                                                <TableCell>{(item.Month === 1 || item.Day === 31 || item.Day === 30) && formatNumber(item.Price)}</TableCell>
                                                <TableCell>{item.Year === 1 && formatNumber(item.Price)}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                                }
                            </TableContainer>
                            }

                            {/* === wifi === */}
                            {currentSub.type === "wifi" &&
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{textAlign: "center"}}><strong>WiFi - Détail</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!isEmpty(currentSub.day) && !isEmpty(currentSub.day.timePrice) && currentSub.day.timePrice.map((item, idx) =>
                                            <TableRow key={idx}>
                                                <TableCell>{item.Day} jour(s)</TableCell>
                                                <TableCell>{formatNumber(item.Price)}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            }

                        </Grid>
                        <Grid item xs={12} sm={4}>
                            {/* <Box p={1}>
                                <div className="card card-button"
                                    onClick={() => this.state.form === "updateFORMS" ?
                                        this.setState({form: ""}) : 
                                        this.setState({form: "updateFORMS"})
                                    }
                                    title="Changer Questionnaire"
                                >
                                    <div>
                                        <TabletMacRounded color="primary"/>
                                    </div>
                                    <h4>Changer Questionnaire</h4>
                                </div> */}
                                {this.state.form === "updateFORMS" && 
                                    <SubscriptionUpdateForms
                                        {...this.state}
                                        subscriptionID={currentSub.id}
                                        handleClose={() => this.setState({form: ""}) }
                                    />
                                }
                                <CardButton
                                    icon={<TabletMacRounded color="primary"/>}
                                    title="Changer Questionnaire"
                                    action={() => this.state.form === "updateFORMS" ?
                                        this.setState({form: ""}) : 
                                        this.setState({form: "updateFORMS"})
                                    }
                                />
                                
                                <CardButton
                                    icon={<LocalShippingRounded color="secondary"/>}
                                    title="Ajouter option stock"
                                    action={() => this.changeStockManagement(currentSub)}
                                    disabled={this.props.STATE.subscriptions.fetching}
                                />

                                {(currentSub.type === "jouly-prepaid-kwh" || currentSub.type === "prepaid-kwh-v2" || currentSub.type === "jouly-prepaid-kwh-limit-day") &&
                                <>
                                    <CardButton
                                        icon={<PlayArrowRounded style={{color: '#4caf50'}}/>}
                                        title="Simuler un paiement"
                                        action={() => this.setState({form: this.state.form === "simulPrepaid" ? "" : "simulPrepaid"})}
                                    />
                                    {this.state.form === "simulPrepaid" && currentSub.type === "prepaid-kwh-v2" &&
                                        <NewSimulPrepaid
                                            close={() => this.setState({form: ""})}
                                            FixCost={currentSub.prepaid_kwh ? currentSub.prepaid_kwh.fixcost : 0}
                                            ConnexionCost={currentSub.prepaid_kwh ? (currentSub.prepaid_kwh.installCost || currentSub.deposit) : currentSub.deposit}
                                            DayDeposit={currentSub.prepaid_kwh ? currentSub.prepaid_kwh.initialkWh : 0}
                                            period={currentSub.prepaid_kwh && currentSub.prepaid_kwh.pricestepList ? currentSub.prepaid_kwh.pricestepList.map(s => ({days: s.kwh, price: s.price})) : []}
                                            MaxPower={currentSub.prepaid_kwh ? currentSub.prepaid_kwh.maxpower : 0}
                                        />
                                    }
                                    {this.state.form === "simulPrepaid" && (currentSub.type === "jouly-prepaid-kwh" || currentSub.type === "jouly-prepaid-kwh-limit-day") &&
                                        <NewSimulPrepaid
                                            close={() => this.setState({form: ""})}
                                            FixCost={currentSub.prepaid_kwh ? currentSub.prepaid_kwh.fixcost : 0}
                                            ConnexionCost={currentSub.prepaid_kwh ? (currentSub.prepaid_kwh.installCost || currentSub.deposit) : currentSub.deposit}
                                            DayDeposit={currentSub.prepaid_kwh ? currentSub.prepaid_kwh.initialkWh : 0}
                                            period={currentSub.prepaid_kwh && currentSub.prepaid_kwh.pricestepList && currentSub.prepaid_kwh.pricestepList[0] ? [{days: 0, price: currentSub.prepaid_kwh.pricestepList[0].price / currentSub.prepaid_kwh.pricestepList[0].kwh}] : []}
                                            MaxPower={currentSub.prepaid_kwh ? currentSub.prepaid_kwh.maxpower : 0}
                                            originalPriceStep={currentSub.prepaid_kwh && currentSub.prepaid_kwh.pricestepList && currentSub.prepaid_kwh.pricestepList[0] ? currentSub.prepaid_kwh.pricestepList[0] : null}
                                        />
                                    }
                                </>
                                }

                                {/* <div
                                    className="card card-button"
                                    onClick={() => this.changeStockManagement(currentSub)}
                                    title="Ajouter option stock">
                                    <div>
                                        <LocalShippingRounded color="secondary" />
                                    </div>
                                    <h4>Ajouter option stock</h4>
                                </div>
                            </Box>   */}
                        </Grid>
                    </Grid>
                </Dialog>
                }

                {/* <h3>Abonnements</h3> */}
                {/* <Grid container spacing={2} >
                    <Grid item sm={3} xs={12}>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={()=>
                                this.setState({ new: true })
                            }>Nouveau</Button>
                    </Grid>
                    <Grid item sm={9} xs={12}>
                    </Grid>
                        
                </Grid> */}
                <SearchBarAction list={ SUBSCRIPTIONS } filterList={this.filterList}  action={()=> this.setState({ new: true }) } name="searchCustom"/>
                
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Mensualite</TableCell>
                            <TableCell>Prix Total</TableCell>
                            <TableCell>Options</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isEmpty(SUBSCRIPTIONS) && this.state.list.map(ID => {
                                let subscription = SUBSCRIPTIONS[ID]
                                return (
                                    <TableRow key={ID}>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.name}</TableCell>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.type}</TableCell>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.mensualite}</TableCell>
                                        <TableCell onClick={() => this.setState({openDialog: true, currentSub: subscription})}>{subscription.total}</TableCell>
                                        <TableCell>
                                            {subscribed_list && subscribed_list.includes(ID) ? 
                                                <Button
                                                    variant="contained"
                                                    color={subscription.status === "Disabled"
                                                    ? "primary"
                                                    : "secondary"}
                                                    onClick={() => this.disableSubscription(subscription)}
                                                >
                                                    {subscription.status === "Disabled"
                                                    ? "Enable"
                                                    : "Disable"}
                                                </Button>
                                                : <Button
                                                    variant="contained"
                                                    color="error"
                                                    onClick={() => this.setState({
                                                        deleteSub: subscription, 
                                                        dialogDelete: true})
                                                    }
                                                >
                                                    Supprimer
                                                </Button>
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                        }

                    </TableBody>
                </TableLayout>
            </PageAdmin>
        );
    }
}

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = (dispatch) => ({
    disableSubscription: (info) => dispatch(disableSubscription(info)),
    changeStockManagementSubscription: (info) => dispatch(changeStockManagementSubscription(info)),
    getClients: () => dispatch(getPaygClients()),

});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionsList);
